
import { Vue, Options, prop } from "vue-class-component";
import OverlayPanel from "primevue/overlaypanel";
import Icons from "@/app/ui/components/icons/index.vue";

type PrintAllFormat = "a6" | "a4";

interface PrintOption {
  label: string;
  value: PrintAllFormat;
  testId: string;
}

class Props {
  data = prop<any[]>({ required: true });

  isSuccessBooking = prop<boolean>({ required: true });
  isNotBooked = prop<boolean>({ required: true });
  isFailedBooking = prop<boolean>({ required: true });
  isAscendingSort = prop<boolean>({ required: true });
}

@Options({
  emits: [
    "update:isSuccessBooking",
    "update:isNotBooked",
    "update:isFailedBooking",
    "update:isAscendingSort",
    "printAll"
  ],
  components: {
    OverlayPanel,
    Icons
  },
})
export default class ShipmentStatusHeader extends Vue.with(Props) {
  showPrintDropdown = false;

  get printOptions(): PrintOption[] {
    return [
      {
        label: String(this.$t("bookingShipment.appsMarketplace.receiptA6")),
        value: "a6",
        testId: "booking-status-header-print-all-option-a6"
      },
      {
        label: String(this.$t("bookingShipment.appsMarketplace.receiptA4")),
        value: "a4",
        testId: "booking-status-header-print-all-option-a4"
      }
    ];
  }

  get shipmentAndSttCounts() {
    let totalStt = 0;
    let totalShipment = 0;

    for (const group of this.data) {
      if (!group.data.length) continue;

      totalShipment += group.data.length;

      for (const item of group.data) {
        if (item.STT?.sttNo) {
          totalStt++;
        }
      }
    }

    return {
      totalShipment,
      totalStt
    };
  }

  get statusCounts() {
    let total = 0;
    let success = 0;
    let failed = 0;

    for (const group of this.data) {
      for (const item of group.data) {
        total++;
        if (item.STT?.sttNo) {
          success++;
        } else if (item.error) {
          failed++;
        }
      }
    }

    const notBooked = total - success - failed;

    return { total, success, failed, notBooked };
  }

  onToggleStatus(status: "success" | "notBooked" | "failed") {
    const isAlreadyActive =
      (status === "success" && this.isSuccessBooking) ||
      (status === "notBooked" && this.isNotBooked) ||
      (status === "failed" && this.isFailedBooking);

    if (isAlreadyActive) {
      this.$emit("update:isSuccessBooking", false);
      this.$emit("update:isNotBooked", false);
      this.$emit("update:isFailedBooking", false);
    } else {
      this.$emit("update:isSuccessBooking", status === "success");
      this.$emit("update:isNotBooked", status === "notBooked");
      this.$emit("update:isFailedBooking", status === "failed");
    }
  }

  toggleSort() {
    this.$emit("update:isAscendingSort", !this.isAscendingSort);
  }

  emitPrint(value: PrintAllFormat) {
    this.togglePanel(null);
    this.$emit("printAll", value);
  }
  refs: any = {};
  onSetRefs() {
    this.refs = this.$refs;
  }
  togglePanel(event: any) {
    this.onSetRefs();
    const refs: any = this.refs;
    if (event === null) {
      refs["op"]?.hide();
      return;
    }
    refs["op"]?.toggle(event);
  }

  onPrintDropdownShow() {
    this.showPrintDropdown = true;
  }

  onPrintDropdownHide() {
    this.showPrintDropdown = false;
  }

  isShipmentAPAS(shipmentId: string) {
    return (
      shipmentId.slice(0, 2) === "AP" || shipmentId.slice(0, 2) === "AS"
    );
  }
}
